import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import type { useRequestBetterDocRecommendationMutation as UseRequestBetterDocRecommendationMutationType } from "@/modules/patients/detail/better-doc/de/services/__generated__/useRequestBetterDocRecommendationMutation.graphql"

const mutation = graphql`
  mutation useRequestBetterDocRecommendationMutation($input: De_requestBetterDocRecommendationInput!) {
    requestBetterDocRecommendation: de_requestBetterDocRecommendation(input: $input) {
      requestBetterDocRecommendationResult: de_RequestBetterDocRecommendationResult {
        sessionId
        outcome
        betterDocState
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useRequestBetterDocRecommendationMutation = () =>
  useMutationWithErrorToast<UseRequestBetterDocRecommendationMutationType>(mutation, {
    errorMessage: "episodeOfCare.betterDoc.error.sendRequestFailed",
  })
